import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-chained-backend';
import Fetch from 'i18next-fetch-backend';
import { appInsights } from './services/ApplicationInsightsService';

export default function configureI18n({ i18nextConfig }) {
  i18n
    .use(Backend)
    .use(LanguageDetector) // detect from browser & cache
    .use(initReactI18next)
    .init({
      fallbackLng: 'en', // fallback when browser language is not supported
      backend: {
        backends: [Fetch],
        backendOptions: [
          {
            loadPath: `/locales/{{lng}}.json`
          }
        ]
      },
      detection: {
        order: ['localStorage', 'cookie', 'navigator', 'htmlTag'], // detect browser language
        caches: ['localStorage', 'cookie'], // persist chosen language
        excludeCacheFor: ['cimode'] // skip for testing mode
      },
      whitelist: i18nextConfig.whitelist,
      nonExplicitWhitelist: true,
      load: 'currentOnly',
      debug: false,
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: true
      }
    });

    // i18n.on('languageChanged', (lng) => {
    //   // Ignore first init call if it's same as auto-detected
    //   if (lng !== i18n.language) return;

    //   appInsights.trackEvent({
    //     name: 'LanguageManuallyChanged',
    //     properties: {
    //       language: lng,
    //       from: 'manual'
    //     }
    //   });
    // });

  return i18n;
}
